import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Massage from "@/pages/Massage";
import Login from "@/pages/Login";
import Staff from "@/pages/Staff";
import AdminDashboard from "@/pages/AdminDashboard";
import PartnerDashboard from "@/pages/PartnerDashboard";
import Board from "@/pages/Board";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/massage/:slug" element={<Massage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/staff" element={<ProtectedRoute roles={["staff", "manager", "owner"]}><Staff /></ProtectedRoute>} />
            <Route path="/board" element={<ProtectedRoute roles={["staff", "manager", "owner"]}><Board /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["manager", "owner"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/partner" element={<ProtectedRoute roles={["partner", "owner"]}><PartnerDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
